import React from 'react';
import { Card, Col, Row, Container } from 'react-bootstrap';
import ella from '../assest/images/ella.jpg'
import Southcoast from '../assest/images/south coast.jpg';
import westcoast from '../assest/images/west coast.jpg';
import sigiriya from '../assest/images/sigiriya.jpg';
import eastcoast from '../assest/images/east coast.jpg';
import yala from '../assest/images/yala.jpg'
import  '../card.css';
function Destinations() {
  const places=[
        {name:"Hill Country " ,image:ella, description :"Misty escapes to Kandy, Nuwara Eliya, Ella, and Haputale"},
        {name:"South coastal " ,image:Southcoast, description :"Beach vibes from Bentota to Mirissa, Galle, Hiriketiya & more"},
        {name:"West Coastal " ,image:westcoast, description :"Relax by the shores of Negombo, Waikkal, Marawila, and Kalpitiya"},
        {name:"East Coastal" ,image:eastcoast, description :"East coast bliss at Arugam Bay, Pasikuda, Nilaveli & Trincomalee"},
        {name:"Historical and Cultural " ,image:sigiriya, description :"Explore ancient wonders of Anuradhapura, Polonnaruwa, Sigiriya & Dambulla"},
        {name:"Wildlife and nature " ,image:yala, description :"Not just a destination, a natural experience."}
    ];


  return (
    <Container className="my-5" id="destinations">
      <h2>Popular Destinations</h2>
      <Row>
        {places.map((place, index) => (
          <Col key={index} md={4} className="my-2">
            <Card>
              <Card.Img variant="top" src={place.image} className="img" />

              <Card.Body>
                <Card.Title>{place.name}</Card.Title>
                <Card.Text>{place.description}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default Destinations;
